import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = ["aria-labelledby", "data-testid"];
const _hoisted_2 = { class: "flex flex-col items-center gap-6 max-w-[560px] text-center" };
const _hoisted_3 = { class: "flex flex-col gap-2" };
const _hoisted_4 = ["id"];
const _hoisted_5 = { class: "font-inter text-base font-normal leading-6 text-[var(--colors-text-body)] whitespace-pre-line m-0" };
const _hoisted_6 = { class: "flex flex-col items-center gap-3.5" };
const _hoisted_7 = ["href"];
import { computed } from "vue";
import { useRouter } from "vue-router";
import { Button } from "@eudonet/opal";
import { configService } from "@/infrastructure/services/ConfigService";
import ErrorIllustration from "./ErrorIllustration.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ErrorPage',
    props: {
        code: {},
        titleKey: {},
        descriptionKey: {},
        homePath: { default: "/" },
        supportHref: { default: undefined }
    },
    setup(__props) {
        const props = __props;
        const router = useRouter();
        const titleId = computed(() => `error-page-title-${props.code}`);
        const resolvedSupportHref = computed(() => props.supportHref ?? configService.api?.supportContactUrl);
        function goHome() {
            router.push(props.homePath);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("section", {
                class: "error-page flex-1 flex items-center justify-center min-h-full w-full px-6 py-8",
                "aria-labelledby": titleId.value,
                "data-testid": `error-page-${__props.code}`
            }, [
                _createElementVNode("div", _hoisted_2, [
                    _createVNode(ErrorIllustration, {
                        "aria-label": _ctx.$t('errorPage.illustrationAlt', { code: __props.code })
                    }, null, 8 /* PROPS */, ["aria-label"]),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("h1", {
                            id: titleId.value,
                            "data-testid": "error-page-title",
                            class: "font-inter text-[1.75rem] font-bold leading-[2.125rem] text-[var(--colors-text-heading)] m-0"
                        }, _toDisplayString(_ctx.$t(__props.titleKey)), 9 /* TEXT, PROPS */, _hoisted_4),
                        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t(__props.descriptionKey)), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_unref(Button), {
                            variant: "primary",
                            size: "lg",
                            "data-testid": "error-page-back-home",
                            label: _ctx.$t('errorPage.backHome'),
                            onClick: goHome
                        }, null, 8 /* PROPS */, ["label"]),
                        (resolvedSupportHref.value)
                            ? (_openBlock(), _createElementBlock("a", {
                                key: 0,
                                class: "font-inter text-sm font-medium leading-5 text-[var(--colors-text-link)] underline underline-offset-2 hover:opacity-80 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-royalblue rounded-[2px]",
                                href: resolvedSupportHref.value,
                                target: "_blank",
                                rel: "noopener noreferrer"
                            }, _toDisplayString(_ctx.$t("errorPage.contactSupport")), 9 /* TEXT, PROPS */, _hoisted_7))
                            : _createCommentVNode("v-if", true)
                    ])
                ])
            ], 8 /* PROPS */, _hoisted_1));
        };
    }
});
